import React, { useState } from 'react';
import IconButton from '../../../muiComponents/IconButton';
import Tooltip from '../../../muiComponents/Tooltip';
import { Menu as MuiMenu, MenuItem, Divider } from '@mui/material';
import Icon from '../../../muiComponents/Icon';
import useUserProfile from '../../../customHooks/useUserProfile';

const Menu = props => {
    const { icon = 'MoreVert', menuItems } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const { translate } = useUserProfile();

    const handleClick = event => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip titleText='menu_open'>
                <span>
                    <IconButton
                        color='secondary'
                        shape='rounded'
                        iconName={icon}
                        onClick={handleClick}
                    />
                </span>
            </Tooltip>
            <MuiMenu
                anchorEl={anchorEl}
                id='edit-menu'
                open={isOpen}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {menuItems.map(item => {
                    if (item.type === 'divider') {
                        return <Divider key={Math.random()} />;
                    }

                    return (
                        <MenuItem
                            key={item.text}
                            onClick={e => {
                                e.stopPropagation();
                                item.onClick && item.onClick();
                                handleClose();
                            }}
                            className={`flex-align-baseline gap-10 ${
                                item.className || ''
                            }`}
                            disabled={item.disabled}
                        >
                            {item.icon && (
                                <Icon iconName={item.icon} color='secondary' />
                            )}
                            <p className='text-capitalize'>
                                {translate(item.text)}
                            </p>
                        </MenuItem>
                    );
                })}
            </MuiMenu>
        </>
    );
};

export default Menu;
